import React, { useEffect, useState } from 'react';
import { Layout, Button, Drawer, Dropdown } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {GRAY_1, GREE_1} from '../../utils/colors';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import AdminMenu from '../../components/admin/AdminMenu';
import {
    LogoutOutlined,
    UserOutlined,
    MenuOutlined,
    DownOutlined
} from '@ant-design/icons';
import {ROUTES} from "../../constants/PathRoutes";
import LogoImg from '../../assets/imgs/logo.png';
const { Header, Sider, Content } = Layout;


const hideSiderSize = '1020px'
const StyledLayout = styled(Layout)`
  min-height: 100vh;
`;

const StyledHeader = styled(Header)`
  background: ${GREE_1};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px 0 0;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
    //background: white;
`;

const MenuButton = styled(Button)`
  color: white;
  border: none;

  &:hover {
    color: white !important;
    background: rgba(255, 255, 255, 0.1) !important;
  }

  @media (min-width: ${hideSiderSize}) {
    display: none;
  }
`;
const ImageLogo = styled.img`
    max-width: 100%;
    width: 200px;
    background: white;
    padding: 7px;
    border-bottom: 2px solid ${GRAY_1};
    @media (max-width: ${hideSiderSize}) {
        display: none;
    }

`
const Logo = styled.div`
  color: white;
  font-size: 20px;
  font-weight: bold;
`;

const UserActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const UserDropdownButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 6px;
  transition: background 0.3s;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  .user-name {
    @media (max-width: ${hideSiderSize}) {
      display: none;
    }
  }
`;

const StyledSider = styled(Sider)`
  background: #fff;

  @media (max-width: ${hideSiderSize}) {
    display: none;
  }
`;

const StyledContent = styled(Content)`
  margin: 24px;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  min-height: 280px;
`;

export default function AdminLayout() {
    const location = useLocation();
    const navigate = useNavigate();
    const { user, logout } = useAdminAuth();
    const [drawerVisible, setDrawerVisible] = useState(false);

    useEffect(() => {
        window.scroll({ top: 0 });
    }, [location]);

    useEffect(() => {
        // Fecha o drawer quando a rota muda
        setDrawerVisible(false);
    }, [location]);

    const handleLogout = () => {
        logout();
        navigate(ROUTES.ADMIN);
    };

    const toggleDrawer = () => {
        setDrawerVisible(!drawerVisible);
    };

    const closeDrawer = () => {
        setDrawerVisible(false);
    };

    // Menu do dropdown do usuário
    const userDropdownMenuItems = [
        // Itens vazios inicialmente, podem ser adicionados depois
        // Exemplo:
        // {
        //     key: 'perfil',
        //     icon: <UserOutlined />,
        //     label: 'Perfil',
        //     onClick: () => navigate('/admin/perfil')
        // },
        // {
        //     type: 'divider'
        // },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Sair',
            danger: true,
            onClick: handleLogout
        }
    ];

    return (
        <StyledLayout>
            <StyledHeader>
                <HeaderLeft>

                      <ImageLogo src={LogoImg}/>
                    <MenuButton
                        type="text"
                        icon={<MenuOutlined />}
                        onClick={toggleDrawer}
                        size="large"
                    />
                    {/*<Logo>CEBRAPCAM Admin</Logo>*/}
                </HeaderLeft>
                <UserActions>
                    <Dropdown
                        menu={{ items: userDropdownMenuItems }}
                        placement="bottomRight"
                        trigger={['click']}
                    >
                        <UserDropdownButton>
                            <UserOutlined style={{ fontSize: '18px' }} />
                            <span className="user-name">
                                {user?.fullname}
                            </span>
                            <DownOutlined style={{ fontSize: '12px' }} />
                        </UserDropdownButton>
                    </Dropdown>
                </UserActions>
            </StyledHeader>

            {/* Drawer para mobile */}
            <Drawer
                title="Menu"
                placement="left"
                onClose={closeDrawer}
                open={drawerVisible}
                width={250}
                styles={{ body: { padding: 0 } }}
            >
                <AdminMenu
                    style={{ borderRight: 0 }}
                    onItemClick={closeDrawer}
                />
            </Drawer>

            <Layout>
                <StyledSider width={200}>
                    <AdminMenu style={{ height: '100%', borderRight: 0 }} />
                </StyledSider>
                <Layout >
                    <StyledContent>
                        <Outlet />
                    </StyledContent>
                </Layout>
            </Layout>
        </StyledLayout>
    );
}
